import React, { useEffect, useState } from "react";
// import { commonAPICall, CONTEXT_HEADING, DYNAMIC_REPORT, GET_PG_TABLES, myAxios } from "../services/utils";
// import { Card, Col, Row } from "react-bootstrap";
import { Form, FormikProvider, useFormik, Field, ErrorMessage } from "formik";

// import { toast } from "react-toastify";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
// import { hideLoader, showLoader, showMessage } from "../actions";
import { useLocation } from "react-router-dom";
import Select from 'react-select';
import Menubar from "./Menubar";
import { Container, Row, Col,Card, Nav, Button, Modal } from 'react-bootstrap';
import ShowReport from "./ShowReport";
// import Table from "./Table";
import { LuNotebookText } from "react-icons/lu";
import MasterService from "../Services/MasterService";
import KpiService from "../Services/KpiService";

import { store } from "../App";
import useAlert from "./Alert/useAlert";
import AlertModal from "./Alert/AlertModal";

const QueryExplorer = () => {
  const { showAlert, alertData, showAlertMessage, closeAlert } = useAlert();
  const [data, setData] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    setData(null);
  }, [location]);

  // const SubmitDetails = async (values, { resetForm }) => {
  //   dispatch(showLoader());
  //   let msg;
  //   let msgType;
  //   try {
  //     const response = await myAxios.post(
  //       DYNAMIC_REPORT,{"searchQuery":values.searchQuery,"authorizationCode":values.authorizationCode}
  //     );
  //     if (response.status === 200) {
  //       if (response.data.message !== "success") {
  //         toast.success(response.data.message);
  //       }
  //       setData(response.data);
  //       msg = response.data.message;
  //       msgType = "success";
  //     } 
  //     else {
  //       msg = response.data.message;
  //       msgType = "failure";
  //       toast.error("Error:" + response.data.message);
  //       setData(null);
  //       formik.setFieldValue("authorizationCode","")
  //     }
  //   } catch (error) {
  //     setData(null);
  //     formik.setFieldValue("authorizationCode","")
  //     if (error.response) {
  //       if (error.response.status === 404) {
  //         msg = "The requested resource was not found.";
  //         msgType = "failure";
  //       } else {
  //         msg = `${error.response.data.message}`;
  //         msgType = "failure";
  //       }
  //     } else {
  //       msg = error.message;
  //       msgType = "failure";
  //     }
  //     toast.error(msg);
  //   }
  //   dispatch(hideLoader());
  //   dispatch(showMessage(msg, msgType));
  // };


const validationSchema = Yup.object({
  searchQuery: Yup.string().required("*Query Required"),
  authorizationCode: Yup.string().test(
    "authorizationCode",
    "*required",
    function (value, context) {
      const keywords = [
        "create", "alter", "truncate", "rename", "drop",
        "insert", "update", "delete", "grant", "revoke",
        "comment", "merge", "into", "lock", "savepoint"
      ];

      const searchQuery = context.parent?.searchQuery?.toLowerCase?.() || "";
      const containsKeyword = keywords.some((keyword) =>
        searchQuery.includes(keyword)
      );

      if (containsKeyword && !value) {
        return context.parent.createError({ message: "*required" });
      }

      return true;
    }
  ),
});

  

  const formik = useFormik({
    initialValues: { searchQuery: "select now()", authorizationCode: "",pgtable:"" },
    validationSchema: validationSchema,
    onSubmit: {},
  });

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.ctrlKey && event.key === "Enter") 
        {
        event.preventDefault(); 
        formik.handleSubmit();  
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [formik]);
 
  useEffect(() => 
    {
    const fetchData = async () => 
      {
        await getPGTables();
      };
    fetchData();
      }, []);
      const [pgTables, SetPGTables] = useState([])


     

const SubmitDetails = async () => {
  // dispatch(showLoader());
  store.dispatch({ type: "SHOW_SPINNER" })
  let msg;
  let msgType;

  let params = {
      "searchQuery": formik.values.searchQuery,
      "authorizationCode": formik.values.authorizationCode ? formik.values.authorizationCode : ""
  };

  try {
      const response = await KpiService.QueryExplorer(params);

      if (response.data) {
          if (response.data.status === "success") {
              showAlertMessage(response.data.message,"success");
          }
          setData(response.data);
          msg = response.data.message;
          msgType = "success";
      } 
      else {
          msg = response.data.message || "Error occurred";
          msgType = "failure";
          showAlertMessage(msg, "error");
          setData(null);
          formik.setFieldValue("authorizationCode", "");
      }
  } catch (error) {
      setData(null);
      formik.setFieldValue("authorizationCode", "");

      if (error.response) {
          if (error.response.status === 404) {
              msg = "The requested resource was not found.";
              msgType = "failure";
          } else {
              msg = `${error.response.data.message}`;
              msgType = "failure";
          }
      } else {
          msg = error.message;
          msgType = "failure";
      }
      showAlertMessage(msg,"error");
  }

  store.dispatch({ type: "HIDE_SPINNER" })
  // dispatch(showMessage(msg, msgType));
};

const getPGTables = async (values) => 
  {
    try {
      SetPGTables("")
      const response = await MasterService.getAllTables();

      if (response.data) {
  const pgTables = response.data.map(detail => detail.table_name);
  SetPGTables(pgTables);
}
   } 
  catch (error) 
  { 
      SetPGTables([])
      showAlertMessage("Unknown Error Occured...","warning");
  }  
  };
 

const options = pgTables  ? pgTables.map((table_name) => ({ value: table_name,  label: table_name,  })) : [];
  return (
    <>
    <Menubar />

<Container fluid className='map-header mx-2'>
  <div className="sa-title">
   <h2>Query <span>Explorer </span></h2>
  </div>
</Container>
    <Container fluid style ={{width:"90%"}} className='mt-3'>
        <FormikProvider value={formik} >
          <Form onSubmit={formik.handleSubmit}>
            <div className='mandal-container p-4 mb-3'>
   
          
           
            

                  <Row>
                    <Col xs={12} sm={12} lg={6} md={6} xl={6} xxl={6} className='mandal-select'>
                    <label className="mb-1 fw-bold">  Query Explorer </label>
                    <Field name="pgtable">
                                                    {({ field, form }) => (
                                                        <Select
                                                            {...field}
                                                            name="pgtable"
                                                            isSearchable={true}
                                                            isClearable={true}
                                                            options={options}
                                                            placeholder="search table here..."
                                                            getOptionLabel={(option) => option.label}
                                                            getOptionValue={(option) => option.value}
                                                            value={options.find(option => option.value === form.values.pgtable) || null}
                                                          
                                                            onChange={(selectedOption) => {
                                                              const query = selectedOption ? `select * from  ${selectedOption.value} limit 10` : '';
                                                              form.setFieldValue(field.name, selectedOption ? selectedOption.value : '');  
                                                              form.setFieldValue('searchQuery', query); 
                                                              form.submitForm();  
                                                            }}
                                                            menuPortalTarget={document.body}  
                                                            
                                                            
                                                        />
                                                    )}
                                                </Field>
                    </Col>
                  </Row>
                  <br/>
                  <Card style={{padding:'10px',boxShadow:'none'}}>
                  <label className="mb-1 fw-bold">
                      Enter a Query
                    </label>
                    <Card.Body className="d-flex">
                        <div className="card-icon d-flex align-items-center" style={{backgroundColor:'#603913',padding:'20px'}}>
                        <LuNotebookText style={{color:'#fff',fontSize:'20px'}}  />
                        </div>
                    <Field
                        as="textarea"
                        name="searchQuery"
                        id="searchQuery"
                        className="form-control"
                        rows="4"
                        placeholder="Enter your query here"
                        style={{ height: '100px' }}
                      />
                      
                 

                     
                    
                    </Card.Body>
                    <ErrorMessage
                      name="searchQuery"
                      component="div"
                      className="text-danger mt-2"
                    />
                    {(() => {
                      const keywords = [
                        "create",
                        "alter",
                        "truncate",
                        "rename",
                        "drop",
                        "insert",
                        "update",
                        "delete",
                        "grant",
                        "revoke",
                        "comment",
                        "merge",
                        "into",
                      ];

                      const command = keywords.filter((keyword) =>
                        formik.values.searchQuery
                          .trim()
                          .toLowerCase()
                          .includes(keyword)
                      );

                      return (
                        keywords.some((keyword) =>
                          formik.values.searchQuery
                            .trim()
                            .toLowerCase()
                            .includes(keyword)
                        ) && (
                          <div>
                           <label className="mb-1 fw-bold">
                              Enter authorization Code
                            </label>
                            <div className="input-group">
                              {/* <span className="input-group-addon">
                                <i className="fa fa-lock" aria-hidden="true"></i>
                              </span> */}
                              <Field
                                type="password"
                                maxLength="10"
                                name="authorizationCode"
                                id="authorizationCode"
                                className="form-control"
                                placeholder="Enter your authorization code here"
                              />
                            </div>
                            <ErrorMessage
                              name="authorizationCode"
                              component="div"
                              className="text-danger"
                              style={{ marginTop: "-20px" }}
                            />
                            <p
                              className="text-danger"
                              style={{ fontSize: "18px" }}
                            >
                              *It seems you are trying to execute/use the{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {command.join(" , ").toUpperCase()}
                              </span>{" "}
                              command(s), which requires authorization. Please
                              enter the authorization code to proceed.
                            </p>
                          </div>
                        )
                      );
                    })()}
                   <div className="text-end">
                   <Button variant="" size="sm" className="execute-btn me-4" 
                  onClick={SubmitDetails}>
                                            {/* <IoIosReturnLeft style={{ fontSize: "18px", marginLeft: "5px" }} /> */}
                                            Execute Query
                                          </Button>
                   </div>
                      </Card>
                    </div>
                    {/* <ErrorMessage
                      name="searchQuery"
                      component="div"
                      className="text-danger mt-2"
                    />
                    {(() => {
                      const keywords = [
                        "create",
                        "alter",
                        "truncate",
                        "rename",
                        "drop",
                        "insert",
                        "update",
                        "delete",
                        "grant",
                        "revoke",
                        "comment",
                        "merge",
                        "into",
                      ];

                      const command = keywords.filter((keyword) =>
                        formik.values.searchQuery
                          .trim()
                          .toLowerCase()
                          .includes(keyword)
                      );

                      return (
                        keywords.some((keyword) =>
                          formik.values.searchQuery
                            .trim()
                            .toLowerCase()
                            .includes(keyword)
                        ) && (
                          <div>
                            <label
                              htmlFor="authorizationCode"
                              className="font-weight-bold"
                            >
                              Enter authorization Code
                            </label>
                            <div className="input-group">
                              <span className="input-group-addon">
                                <i className="fa fa-lock" aria-hidden="true"></i>
                              </span>
                              <Field
                                type="password"
                                maxLength="10"
                                name="authorizationCode"
                                id="authorizationCode"
                                className="form-control"
                                placeholder="Enter your authorization code here"
                              />
                            </div>
                            <ErrorMessage
                              name="authorizationCode"
                              component="div"
                              className="text-danger"
                              style={{ marginTop: "-20px" }}
                            />
                            <p
                              className="text-danger"
                              style={{ fontSize: "18px" }}
                            >
                              *It seems you are trying to execute/use the{" "}
                              <span style={{ fontWeight: "bold" }}>
                                {command.join(" , ").toUpperCase()}
                              </span>{" "}
                              command(s), which requires authorization. Please
                              enter the authorization code to proceed.
                            </p>
                          </div>
                        )
                      );
                    })()} */}

                    {/* <button
                      type="submit"
                      color="success"
                      className="float-right mt-1 pb-1"
                    >
                      <i className="fa fa-calculator" aria-hidden="true"></i>{" "}
                      Execute Query
                    </button> */}
                 
                {/* </Form>
              </FormikProvider> */}
            {/* </div>
          </div> */}
        {/* </Card.Body>
      </Card> */}
    {/* </div> */}
      <br/>
      <Row>
                    <Col xs={12} sm={12} lg={12} md={12} xl={12} xxl={12}>
      {data != null && 
      <ShowReport dataSet={data} />
    }
    </Col>
    </Row>
      {/* <Table/> */}
      <AlertModal
        show={showAlert}
        titleText={alertData.titleText}
        alertText={alertData.alertText}
        onClose={closeAlert}
      />
      </Form>
      </FormikProvider>
      </Container>
    </>
  );
};

export default QueryExplorer;
